module.exports = __webpack_public_path__ + "static/media/2.4520e16f.jpg";